/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getUserratingsList: (params) => {
    return axios.get(API_ENDPOINTS.GET_USERRATINGS_LIST, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  },
  getDriverratingsList: (params) => {
    return axios.get(API_ENDPOINTS.GET_DRIVERRATINGS_LIST, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  },
};
